module.exports = __webpack_public_path__ + "static/images/spike03.3412c17.png";